export const COMPANY_NUMBERS_KEY = [
    "company-numbers"
] as const;

export const companyNumbersQueryKeys = {
    all: COMPANY_NUMBERS_KEY,
    byCompanyId: (companyId: number) => [...COMPANY_NUMBERS_KEY, companyId] as const,
};
